module.exports = __webpack_public_path__ + "static/media/airbnb_rank.542cd163.csv";